import { createCommandQueue } from '@hc-frontend/utils'
import { sendLead, sendOpportunity, sendPolicy } from './salesforce'
import { removeSalesforceData } from './salesforce/policy/removeSalesforceData'
import { customViews } from './agents/customViews'
import { customState } from './agents/customState'
import forumBanner from './agents/forumBanner'
import { SFErrorHandler } from './salesforce/SFErrorHandler'
import customFiltersByState from './agents/customFiltersByState'

const { runCommands, registerCommand } = createCommandQueue()

function registerCommands() {
  registerCommand('salesforce.send.lead', () => sendLead().catch(SFErrorHandler))
  registerCommand('salesforce.send.opportunity', () =>
    sendOpportunity().catch(SFErrorHandler)
  )
  registerCommand('salesforce.send.policy', () => sendPolicy().catch(SFErrorHandler))
  registerCommand('salesforce.clear', removeSalesforceData)
  registerCommand('agents.filterByState', customFiltersByState)
  registerCommand('agents.custom.views', customViews)
  registerCommand('agents.custom.state', customState)
  registerCommand('agents.forum-banner.display', forumBanner)
}

export { registerCommands, runCommands }
